// ============================================================================
// FIREBASE SDK — INICIALIZAÇÃO SINGLETON
// ARQUIVO: src/shared/api/firebase/config.js
// RESPONSABILIDADE: Única fonte de verdade para instâncias Firebase.
// ============================================================================

import { initializeApp, getApp, getApps } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { FIREBASE_CONFIG } from "../../../config/Config";

const app = getApps().length ? getApp() : initializeApp(FIREBASE_CONFIG);

export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});
export const functions = getFunctions(app, "southamerica-east1");
export const storage = getStorage(app);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Erro na persistência de Auth:", error);
});

// ============================================================================
// RENOVAÇÃO PROATIVA DO TOKEN DE SESSÃO (achado 18/09/2026)
// O SDK do Firebase às vezes NÃO renova o token de ID sozinho depois que a
// aba fica muito tempo em segundo plano, ou o computador dorme/perde
// energia — mesmo com o login continuando "válido" por trás das cenas.
// Sintoma real: "Missing or insufficient permissions" ao voltar pra aba, só
// resolvido antes com logout/login manual, nem sempre resolvido só com F5
// (a sessão restaurada pode carregar o mesmo token velho).
// Cobre os dois gatilhos mais comuns: aba volta a ficar visível, e a
// restauração inicial da sessão ao carregar a página.
// ============================================================================
function forceTokenRefresh(user) {
  if (!user) return;
  user.getIdToken(true).catch((err) => {
    console.warn("Falha ao renovar token de sessão:", err.message);
    // A sessão realmente morreu (não é hiccup de rede) — força logout pra
    // cair na tela de login limpa, em vez de deixar a tela presa mostrando
    // erro de permissão sem explicação nenhuma pro usuário.
    const deadSessionCodes = [
      "auth/user-token-expired",
      "auth/user-disabled",
      "auth/invalid-user-token",
    ];
    if (deadSessionCodes.includes(err.code)) {
      signOut(auth).catch(() => {});
    }
  });
}

onAuthStateChanged(auth, (user) => forceTokenRefresh(user));

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      forceTokenRefresh(auth.currentUser);
    }
  });
}
